/* eslint-disable radix */
import React, { useEffect, useState } from 'react';
import { Navigate, useNavigate } from 'react-router-dom';
import PropTypes from 'prop-types';
import { useDispatch, useSelector } from 'react-redux';
import LoadingScreen from '../../components/LoadingScreen';
import { useAuth } from '@clerk/clerk-react';
import Cookie from '../../utils/Cookie';

const GuestGuard = ({ children }) => {
  const { isAuthenticated, user } = useAuth();
  const dispatch = useDispatch()
  const [loading, setLoading] = useState(false)
  const { isSignedIn, isLoaded } = useAuth();
  const userType = Cookie.getCookie('userType');
  // const { isAuthenticated,user } = useSelector((state) => state.user);

  // let localAuthentication =  localStorage.getItem('isAuthenticated')
  // let token = localStorage.getItem('token')
  // if (!isAuthenticated && user === null) {
  //   return <Navigate to="/login" />;
  // }
  const navigate = useNavigate()

  useEffect(() => {
    // const getmyData = async () => {
    //   try {
    //     setLoading(true)
    //     let response = await ME();
    //     console.log('response', response)
    //     if (response?.status === 200) {
    //       localStorage.setItem('isAuthenticated', true)
    //       dispatch(setAuthUserState({
    //         isAuthenticated: "authenticated",
    //         isInitialized: true,
    //         user: response?.data?.data,
    //       }))
    //       setLoading(false)
    //       navigate('/login')
    //     }
    //     if (response && response?.status === 401) {
    //       setLoading(false)
    //       navigate('/login')
    //     } else if (response && response?.status === 422) {
    //       setLoading(false)
    //       navigate('/login')
    //     }

    //   } catch (err) {
    //     console.log("Inside catch block login: ---", err);
    //     setLoading(false)
    //     navigate('/login')
    //   }
    // }
    // getmyData()
  }, [])

  if (!isLoaded) {
    return <LoadingScreen />
  }
  // if (isAuthenticated === 'disconnected' && user === null) {
  //   return <Navigate to="/login" />;
  // }

  // console.log('isSignedIn', isSignedIn)
  // if (isSignedIn && userType === 'user') {
  //   return <Navigate to="/user/creator-list" />
  // }
  // if (isSignedIn && userType === 'creator') {
  //   return <Navigate to="/user/creator-list" />
  // }
  if (isSignedIn) {
    return <Navigate to="/user/creator-list" />
  }
  return (
    <>
      {children}
    </>
  );
};

GuestGuard.propTypes = {
  children: PropTypes.node.isRequired,
};

export default GuestGuard;
